import React from 'react';
import {ButtonImage} from './styles';
import Button from 'shared/migration-components/button';
import logo from '../../assets/images/google.png';
import {CodeResponse, useGoogleLogin} from '@react-oauth/google';
import useSocialLoginGoogleCode from 'modules/auth/hooks/use-social-login-google-code';

const GoogleAuthButton: React.FC = () => {
  const {mutate, isLoading} = useSocialLoginGoogleCode();

  const handleLogin = async ({code}: CodeResponse) => {
    mutate({code});
  };

  console.log(`${window.location.origin}/login`);

  const login = useGoogleLogin({
    onSuccess: handleLogin,
    flow: 'auth-code',
    redirect_uri: `${window.location.origin}/login`,
  });

  return (
    <Button
      onClick={login}
      icon={<ButtonImage src={logo} />}
      title="Entrar com o Google"
      widthMode="expand"
      style={{backgroundColor: 'rgb(38, 38, 38)'}}
      loading={isLoading}
    />
  );
};

export default GoogleAuthButton;
